import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import {errorCollection} from "@/api/dmp/dmpCollection";
/**
 * 上传操作记录日志
 */
export function operations(params) {
  const url = IhLogUrl + '/operations'

  return axios({
    method: 'post',
    url: url,
    data: params
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('实时监控', '上传操作记录日志', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 上传一键求助记录日志
 */
export function emergencyHelpLog(params) {
  const url = IhLogUrl + '/emergencyHelp'

  return axios({
    method: 'post',
    url: url,
    data: params
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('实时监控', '上传一键求助记录日志', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 获取一键求助记录日志
 */
export function getEmergencyHelpLog(params) {
  const url = IhLogUrl + '/emergencyHelp/' + params

  return axios({
    method: 'get',
    url: url
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('实时监控', '获取一键求助记录日志', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 查询上一次安全帽状态信息
 */
export function helmetInfo(params) {
  const url = IhLogUrl + '/status/helmetInfo/' + params

  return axios({
    method: 'get',
    url: url
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('实时监控', '查询上一次安全帽状态信息', res)
    }
    return Promise.resolve(res.data)
  })
}
